module.exports = __webpack_public_path__ + "img/cg_6player_poker.049c3e0.jpg";